import { forwardRef } from "react";
import { formatPrice } from "utils/helpers/functions/formatPrice";
import { useSettings } from "context/SettingsContext";

type Props = {
    stockCount: any;
    value: string | number | undefined;
    index: number;
    setFieldValue: (field: string, value: any) => void;
    splitByPrice?: boolean;
};

const colMaxStyle = { flex: '0 0 55px', minWidth: '55px' };
const colPriceStyle = { flex: '0 0 120px', minWidth: '120px' };
const colRateStyle = { flex: '0 0 55px', minWidth: '55px' };

const TransfetCountInput = forwardRef<HTMLInputElement, Props>(({ stockCount, value, index, setFieldValue, splitByPrice = false }, ref) => {
    const { localSettings } = useSettings();
    const currentRate = Number(localSettings?.RATE?.current ?? 1) || 1;
    const isUahMode = currentRate === 1;

    const price = formatPrice(stockCount?.operPrice);
    const priceRate = formatPrice(stockCount?.operPriceRate);
    const rate = formatPrice(stockCount?.operPriceRate / (stockCount?.operPrice || 1));

    return (
        <div className="input-group mb-2 w-100">
            <input
                className="form-control"
                ref={ref}
                id={`input-transfer-count-${index}`}
                type="number"
                name={`setCount[${index}]`}
                max={stockCount?.stock}
                style={{ flex: '1 1 0', minWidth: '100px' }}
                value={value || ''}
                onChange={(e) => {
                    setFieldValue(`setCount[${index}]`, e.target.value);
                }}
            />
            <span className="input-group-text text-end d-block fs-12 px-2" style={colMaxStyle}>
                {stockCount?.stock}
            </span>
            {splitByPrice && (
                <>
                    <span className="input-group-text px-2 py-1" style={colPriceStyle}>
                        <div className="w-100 text-end lh-1">
                            <div className="fs-12 fw-semibold">
                                {isUahMode ? `₴ ${price}` : `$ ${price}`}
                            </div>
                            {!isUahMode && (
                                <div className="text-muted fs-10" style={{ marginTop: 4 }}>₴ {priceRate}</div>
                            )}
                        </div>
                    </span>
                    {!isUahMode && (
                        <span className="input-group-text fs-12 px-2 py-1 d-block text-end" style={colRateStyle}>
                            {rate}
                        </span>
                    )}
                </>
            )}
        </div>
    );
});

export default TransfetCountInput;
